import React from 'react';
import _ from 'lodash';
import * as storage from './storage';
import { tripStartCountdown } from './bookingDetailsHelper';
import { AutoLogout } from '@/comp/autoLogout';
import { Navigate, useLocation } from 'react-router';
import { AppProvider } from '@/context/AppContext';

export const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    if (storage.get('access_token') === null) {
        if (location.pathname !== '/login' && location.pathname !== 'logout') {
            return <Navigate to="/login" replace state={{ from: location }} />;
        }
    }

    if (location.pathname !== 'login' && location.pathname !== 'logout') {
        document.querySelector('html').classList.remove('redesign');
    }

    return <AppProvider>{window.$affiliate ? children : <AutoLogout>{children}</AutoLogout>}</AppProvider>;
};

export const redirectToPage = (location) => {
    // Für c24 Kundenbereich
    if (sessionStorage.getItem('redirect_page')) {
        window.location.href = '#' + sessionStorage.getItem('redirect_page');
        return true;
    }

    const redirectOption = location.state?.from?.pathname || '/';
    let origin;

    if (_.find(window.$content.redirectPages, redirectOption)) {
        // map routing
        if (_.values(_.find(window.$content.redirectPages, redirectOption))[0] !== true) {
            origin = _.values(_.find(window.$content.redirectPages, redirectOption));
        } else {
            origin = redirectOption;
        }
    } else {
        origin = '/';
    }

    if (_.find(origin, 'linkOut')) {
        if (_.find(origin, 'linkOut').linkOut?.redirectPage !== undefined) {
            // trigger linkout after redirect
            if (_.find(origin, 'linkOut').linkOut?.trigger !== undefined) {
                sessionStorage.setItem('linkOutTrigger', _.find(origin, 'linkOut').linkOut?.trigger);
            }
            origin = _.find(origin, 'linkOut').linkOut?.redirectPage;
        }
    }

    window.location.href = '#' + origin;
};

export function affiliate_checkIsAllowToBookService(service) {
    let checkArr = [];

    if (window.$affiliate) {
        if (window.$affiliateServices && window.$affiliateServices.includes(service)) {
            checkArr.push(service);
        }
    }

    return checkArr;
}

export function checkTripEnded() {
    if (storage.get('bookingData') !== null) {
        const bookingData = storage.get('bookingData');
        if (bookingData?.data && bookingData.data.searchParams?.retDate) {
            let retDate = bookingData.data.searchParams.retDate;
            return new Date(retDate.split('.').reverse().join('/')).getTime() < new Date().getTime();
        }
    }
}

export function checkIsAlreadyBooked() {
    let checkArr = [];
    let railAndFlyDirections = [];

    if (storage.get('bookingData') !== null) {
        let bookingData = storage.get('bookingData');

        function logic(value, key, frontend = false) {
            if (key === 'railAndFly') {
                _.forEach(value, function (railAndFlyValue) {
                    if (frontend) {
                        if (railAndFlyValue.data?.direction !== undefined) {
                            railAndFlyDirections.push(railAndFlyValue.data.direction);
                        }
                    } else {
                        railAndFlyDirections.push(railAndFlyValue.direction);
                    }
                });
            }
        }

        // booked service : IBE
        if (bookingData) {
            if (bookingData.data) {
                if (bookingData.data.serviceInformation) {
                    _.forEach(bookingData.data.serviceInformation, function (value, key) {
                        logic(value, key);
                        checkArr.push(key);
                    });
                }

                /** seatReservation :: all possible seats booked **/
                if (bookingData.data?.isAllPossibleSeatsBooked) {
                    checkArr.push('seatReservation');
                }
            }

            // booked service : frontend
            if (bookingData.bookedService !== null) {
                _.forEach(storage.get('bookingData').bookedService, function (value, key) {
                    logic(value, key, true);
                    checkArr.push(key);
                });
            }
        }

        if (checkArr.length > 0) {
            if (
                !(
                    railAndFlyDirections.includes('both') ||
                    (railAndFlyDirections.includes('inbound') && railAndFlyDirections.includes('outbound'))
                )
            ) {
                let railAndFlyElement = checkArr.indexOf('railAndFly');
                if (railAndFlyElement > -1) {
                    checkArr.splice(railAndFlyElement, 1);
                }
            }
        }
    }

    return checkArr;
}

export function checkIsAllowToBookService(service) {
    let checkArr = [];
    if (storage.get('bookingData') !== null) {
        const { data } = storage.get('bookingData');
        checkArr = checkIsAlreadyBooked();

        // global : affiliate → allowed services
        if (window.$affiliate) {
            _.forEach(!affiliate_checkIsAllowToBookService(service), function (value) {
                checkArr.push(value);
            });
        }

        // global : deactivate extras
        if (!checkArr.includes(service) && window.$deactivateExtras.includes(service)) {
            checkArr.push(service);
        }

        // global : deactivate services
        if (window.deactivateServices.includes(service)) {
            checkArr.push(service);
        }

        // check if apis can be set
        if (service === 'Apis' && tripStartCountdown(data.searchParams.depDate) < 3) {
            checkArr.push(service);
        }
    }

    if (checkArr.length > 0) {
        if (checkArr.includes(service)) {
            window.location.href = '#/';
            return false;
        }
    }
    return true;
}
